import Dashboard from "../dashboard/modules/dashboard/views/dashboardLayout.vue";
import administrator from "./views/administrator";
import administratorList from "./components/administratorList";
import Auth from "../dashboard/modules/auth/middleware/Auth";
import AdminMiddleware from "../dashboard/modules/auth/middleware/AdminMiddleware";
import administratorCard from "./components/administratorCard";
import StudentList from "./components/users/StudentList";
import StudentCard from "./components/users/StudentCard.vue";
import Applications from "./components/applications/Applications";
import AdminSettings from "./components/AdminSettings";
import iblLinks from "./components/iblLinks.vue";
const AdministratorRoutes = [
  {
    path: "/admin",
    component: Dashboard,
    name: "Admin",
    children: [
      {
        path: "",
        component: administrator,
        children: [
          {
            path: "list",
            name: "AdminList",
            component: administratorList,
            meta: { middleware: [Auth, AdminMiddleware] },
          },
          {
            path: "card",
            name: "AdminCard",
            component: administratorCard,
            meta: { middleware: [Auth, AdminMiddleware] },
          },
          {
            path: "students",
            name: "StudentList",
            component: StudentList,
            meta: { middleware: [Auth, AdminMiddleware] },
          },
          {
            path: "card/:reg?",
            name: "StudentCard",
            component: StudentCard,
            meta: { middleware: [Auth] },
          },
          {
            path: "applications/:code?",
            name: "AdminApplications",
            component: Applications,
            meta: { middleware: [Auth] },
          },
          {
            path: "iblLinks",
            name: "iblLinks",
            component: iblLinks,
            meta: { middleware: [Auth] },
          },
          {
            path: "settings",
            name: "AdminSettings",
            component: AdminSettings,
            meta: { middleware: [Auth] },
          },
        ],
      },
    ],
  },
];
export default AdministratorRoutes;
